export * from '../../constant';
export * from './agree-pdf';

export const MAX_BEFORE_IGNORE_VERIFY_CONFIRM = 1; // 认证提示, 关闭n次后, 则出现'不再提示'选项
export const VERIFY_HINTING_CLOSE_COUNT = 'verifyHintingCloseCount';
export const STOP_VERIFY_HINTING = -1;

export const SSO_ENVS = {
  LIVE: 'live',
  DEMO: 'demo',
};

// required的规则未使用
export const VALIDATION_RULE = {
  Customer: {
    mobile: { maxLength: 20 },
    username: { required: true, maxLength: 64 },
    password: { required: true, minLength: 8, maxLength: 32 },
    tradingPassword: { required: true, minLength: 6, maxLength: 16 }, // base on krampus
  },
  Identification: {
    fullName: { required: true, maxLength: 80 },
    number: { required: true, maxLength: 60 },
    type: { required: true },
    expireDate: { required: true },
    givenNameEn: { required: true, maxLength: 20 },
    middleNameEn: { required: false, maxLength: 20 },
    familyNameEn: { required: true, maxLength: 20 },
    idNumber: { required: true, maxLength: 80 },
  },
  BankCard: {
    bank: { required: true },
    currency: { required: true },
    number: { required: true, maxLength: 60 },
    givenNameEn: { required: true, maxLength: 20 },
    middleNameEn: { required: false, maxLength: 20 },
    familyNameEn: { required: true, maxLength: 20 },
    email: { required: false, maxLength: 150 },
    mobile: { required: false, maxLength: 35 },
    bankAccountName: { required: false, maxLength: 80 },
    branchAddress: { required: false, maxLength: 200 },
    pixType: { maxLength: 80 },
    pixKey: { maxLength: 80 },
    pixKeyPhone: { maxLength: 77 },
    ifsc: { maxLength: 80 },
    epayBank: {
        bankId: { maxLength: 100 },
        name: { maxLength: 100 },
        city: { maxLength: 100 },
        address: { maxLength: 100 },
        bankName: { maxLength: 100 },
        locationId: { maxLength: 100 },
        bankBranch: { maxLength: 100 },
    },
    cryptoWalletAddress : { maxLength: 256 }
  },
  Deposit: {
    depositAmount: { required: true, precision: 11 },
    settlementAmount: { required: true, precision: 11 },
    customerRemark: { required: true, maxLength: 200 },
  },
  Withdraw: {
    settlementAmount: { required: true, precision: 11 },
  },
};

export const RECEIVE_METHOD_CONFIG = {
  USDT: {
    qrCode: true,
    number: true,
  },
  WECHAT: {
    qrCode: true,
  },
  BANK: {
    number: true,
  },
};

export const APPLE_ENV_CONTEXT = {
  CLIENT_ID: {
    LOCAL: 'com.meltin.weblogin',
    DEV: 'com.meltin.weblogin',
    UAT: 'com.meltin.weblogin',
    PROD: 'service.hdf.exchange',
  },
  REDIRECT_URI: {
    LOCAL: 'https://cms.claus.nextop.cn',
    DEV: 'https://cms.claus.nextop.cn',
    UAT: 'https://cms.claus.nextop.cn',
    PROD: 'https://my.ghftrade.com',
  },
};

export const USERNAME_PROVIDER_TYPE = {
    GOOGLE: 'GOOGLE',
    FACEBOOK: 'FACEBOOK',
    APPLE: 'APPLE',
    PASSWORD: 'PASSWORD',
    MAIL_PASSWORD: 'MAIL_PASSWORD',
    PHONE_PASSWORD: 'PHONE_PASSWORD',
};
